import template from './order_packing.html';
import controller from './order_packing.controller';
import './order_packing.scss';

let orderPackingComponent = {
  restrict: 'E',
  template,
  controller
};

export default orderPackingComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/order_packing/order_packing.component.js